import { ReactElement } from "react";
import { Box } from "@twilio-paste/core/box";

import { WiseOwlIngress } from "@twiliointernal/e2-commons-shared-definitions";

import { OscPreChatHeader } from "./sub";

const PreChatUI = ({ ingress }: { ingress: WiseOwlIngress }): ReactElement => {
  const renderPreChatHeader = (): ReactElement => {
    switch (ingress) {
      case WiseOwlIngress.console: {
        return <></>;
      }
      /**
       * Default to any E2 ingress
       * - OSC gated/ungated
       * - Zendesk
       * - One Admin
       * - Salesforce
       */
      default: {
        return <OscPreChatHeader />;
      }
    }
  };

  return (
    <Box overflowY={"auto"} position={"relative"}>
      {renderPreChatHeader()}
    </Box>
  );
};

export default PreChatUI;
